import styled from 'styled-components'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  AI_BANNER_BACKGROUND,
  AI_GRADIENT,
  AI_PINK,
  AI_TERTIARY_TEXT,
} from './aiEvaluationTokens'

export const SuggestionRoot = styled.div`
  margin-top: 20px;
  margin-bottom: 24px;
  padding: 16px;
  display: flex;
  align-items: center;
  gap: 16px;
  border-radius: 16px;
  border: 1px solid ${AI_PINK};
  background: ${AI_BANNER_BACKGROUND};
  font-family: Roboto, sans-serif;
`

export const SuggestionStarIcon = styled.div`
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
`

export const SuggestionBody = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const SuggestionTitle = styled.p`
  margin: 0;
  font-weight: 700;
  color: ${AI_TERTIARY_TEXT};
  font-size: 18px;
  line-height: 26px;
`

export const SuggestionCopy = styled.div`
  display: flex;
  flex-direction: column;
`

export const SuggestionParagraph = styled.p`
  margin: 0;
  font-size: 16px;
  font-weight: 400;
  color: ${AI_TERTIARY_TEXT};
  line-height: 24px;

  strong {
    font-weight: 600;
  }
`

export const SuggestionCta = styled.button`
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  height: 40px;
  padding: 0 16px;
  border: none;
  border-radius: 8px;
  background: ${AI_GRADIENT};
  color: #ffffff;
  font-family: inherit;
  font-weight: 700;
  font-size: 14px;
  line-height: 16px;
  cursor: pointer;
  transition: transform 0.15s ease, box-shadow 0.15s ease, opacity 0.15s ease;

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(255, 93, 44, 0.28);
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 2px rgba(255, 93, 44, 0.3);
  }

  &:active {
    transform: translateY(0);
  }
`

export const SuggestionCtaIcon = styled(FontAwesomeIcon)`
  height: 16px !important;
  width: 16px !important;
  color: #ffffff !important;
`
